import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useEffect, useState } from "react";

import toast from "react-hot-toast";

const useMapBodyType = () => {
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  // const navigate = useNavigate();
  // const { addToast } = useToasts();

  const [productsData, setProductsData] = useState([]);
  const [bodyTypes, setBodyTypes] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selection, setSelection] = useState([]);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState([]);
  const [totalRecords, setTotalRecords] = useState([]);
  const dispatch = useDispatch();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (productId, bodyTypeId) => {
    const findProduct = selection?.find(
      (prod) => prod.iProductId === productId
    );
    if (!findProduct) {
      setSelection((prev) => [
        ...prev,
        {
          iProductId: productId,
          iBodyTypeId: parseInt(bodyTypeId),
        },
      ]);
    } else {
      const selected = selection.filter((prod) => {
        return prod.iProductId !== productId;
      });
      setSelection(selected);
    }
  };

  const getProducts = async () => {
    try {
      setLoader(true);
      const response = await apiHandler({
        url: `${endpoint.GET_MISSING_PRODUCTS}?iPageNumber=${currentPage}&iPageSize=10`,
        authToken: authData,
        method: "GET",
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        setProductsData(response.data.data.productData);
        setBodyTypes(response.data.data.filters.bodyTypeFilter);
        setTotalRecords(response.data.data.totalRecords);
      }
    } catch (error) {
      console.log("Error getting products", error);
    } finally {
      setLoader(false);
    }
  };

  const updateProducts = async () => {
    try {
      setSubmitLoader(true);
      const response = await apiHandler({
        url: endpoint.PATCH_MISSING_PRODUCTS,
        authToken: authData,
        method: "POST",
        data: {
          aProductJson: selection,
        },
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        toast.success(response.data.message);
        setShowConfirmation(false);
        setSelection([]);
        getProducts();
      }
    } catch (error) {
      console.log("Error updating products", error);
    } finally {
      console.log("cllled");

      setSubmitLoader(false);
    }
  };

  useEffect(() => {
    getProducts();
  }, [currentPage]);

  return {
    loader,
    productsData,
    bodyTypes,
    showConfirmation,
    setShowConfirmation,
    handleChange,
    selection,
    setSelection,
    updateProducts,
    submitLoader,
    totalRecords,
    currentPage,
    handlePageChange,
  };
};

export default useMapBodyType;
